import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI, { Message, MessageBox } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 配置axios
axios.defaults.baseURL = '/api'
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

axios.interceptors.response.use(
  response => response.data,
  error => {
    if (error.response && error.response.status === 401) {
      const reason = error.response.headers && error.response.headers['x-logout-reason']
      if (reason === 'other_device') {
        Message.warning('您的账号已在其他设备登录，请重新登录')
      }
      localStorage.removeItem('token')
      store.commit('CLEAR_AUTH')
      // 仅在当前页面需要登录时才跳转登录页，弹窗确认后再跳转
      const needAuth = router.currentRoute && router.currentRoute.meta && router.currentRoute.meta.requiresAuth
      if (needAuth && router.currentRoute.path !== '/login') {
        MessageBox.alert('请先登录，解锁精彩课程内容', '温馨提醒', {
          confirmButtonText: '去登录',
          type: 'info',
          customClass: 'login-prompt-dialog',
          callback: () => {
            router.replace('/login').catch(err => {
              const ignore = err.name === 'NavigationDuplicated' ||
                err.name === 'NavigationCancelled' ||
                err.name === 'NavigationAborted' ||
                (err.message && err.message.includes('Redirected'))
              if (!ignore) console.error(err)
            })
          }
        })
      }
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$http = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

